import React from 'react';
import { CheckoutButton } from '../CheckoutButton';
import { GUARANTEE_LINE, VOLUMES } from '../../data/welding';
import { PRICE } from '../../data/checkout';
export function FinalCta() {
  return <section aria-labelledby="final-title" className="blueprint-grid bg-surface py-14 sm:py-20" data-id="element-179" data-mp="1nphtmo0qc6on">
      <div className="mx-auto flex w-full max-w-3xl flex-col items-center px-5 text-center sm:px-8" data-id="element-180" data-mp="1snj8ewr4hjub">
        <ul className="grid w-full max-w-md grid-cols-6 gap-1.5" aria-hidden data-id="element-181" data-mp="1enrz39bjwrmn">
          {VOLUMES.map(volume => <li key={volume.number} data-id="element-182" data-mp="1iqy82oq1swwt">
              <img src={volume.src} alt="" width={volume.width} height={volume.height} loading="lazy" decoding="async" className="aspect-[4/5] w-full rounded-[3px] object-contain ring-1 ring-white/10" data-id="element-183" data-mp="1insfgzi7ncwc" />
            </li>)}
        </ul>
        <h2 id="final-title" className="mt-8 font-heading text-[2rem] font-bold uppercase leading-[0.98] text-white min-[390px]:text-[2.15rem] sm:text-[2.7rem] lg:text-[3.1rem]" data-id="element-184" data-mp="341wxg4xm45bx">
          VOTRE PROCHAIN PROJET D’ATELIER COMMENCE PAR UN PLAN.
        </h2>
        <p className="mt-4 text-[1.02rem] leading-relaxed text-steel-pale sm:text-[1.1rem]" data-id="element-185" data-mp="b0dicbed5s74">
          Obtenez les 30 projets, les six volumes et les cinq ressources bonus.
        </p>
        <CheckoutButton id="final-cta" label={`OBTENIR LA COLLECTION — ${PRICE.label}`} size="lg" className="mt-7 w-full sm:w-auto" data-id="element-186" data-mp="3ff51keyc91ou" />
        <p className="mt-6 max-w-md text-[0.8rem] leading-relaxed text-white/55" data-id="element-187" data-mp="3og35yycovb7y">{GUARANTEE_LINE}</p>
      </div>
    </section>;
}